<template lang="pug">
  include Purchases.pug
</template>

<script type="text/javascript">
import api from "@/service/api"
import { mapState } from "vuex";
import utils from "@/service/utils"

export default {
  name: "Purchases",
  data() {
    return {
      items: [],
    };
  },
  computed: mapState([
    "token", "username",
  ]),
  async created() {
    const purchasesResponse = await api.purchases(this.token)
    this.items = purchasesResponse.data.items
    console.log(this.items)
  },
  filters: {
    price: (newValue) => {
      return utils.price(newValue)
    }
  }
};
</script>
